import { useFormik } from 'formik';
import * as Yup from 'yup';

const CreateUpdateVideoValidationSchema = () =>
  Yup.object().shape({
    description: Yup.string().required('Description is required'),
    thumbnail_url: Yup.string().url('Invalid URL format')
  });

export default function useVideoFormik(videoData = {}, onSubmit) {
  const formik = useFormik({
    initialValues: {
      description: videoData?.description ?? '',
      thumbnail_url: videoData?.thumbnail_url ?? ''
    },
    enableReinitialize: true,
    validationSchema: CreateUpdateVideoValidationSchema,
    onSubmit
  });

  return formik;
}
